interface PolicyConsentState {
  isBlocking: boolean
  isDismissed: boolean
}

export function getPoliciesToShow<T extends PolicyConsentState>(policies: ReadonlyArray<T>): Array<T> {
  return policies.filter((policy) => policy.isBlocking || !policy.isDismissed)
}
